module.exports = __webpack_public_path__ + "static/img/pay_pp_ex_en.7f83e1fe.png";